/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { RESULT } from 'core/data';
import * as monaco from 'monaco-editor';

import { RecordedAction } from '@/pages/projects/LiveAgentTypes';

// These functions / variables will be treated as Playwright functions and
// won't be mapped to a step in the agent.
export const HEAL_PW_FUNCTIONS = [
    'createPage',
    'setCurrentPage',
    'listPages',
    'setPageTabStrategy',
    'readLastEmail',
    'cognitoAuth',
    'setResult',
    'constants',
    'variables',
];

export interface ParsedFunctionCall {
    methodName: string;
    args: any[];
    functionPosition: {
        lineNumberStart: number;
        lineNumberEnd: number;
        columnStart: number;
        columnEnd: number;
    };
    decorationsPosition: {
        lineNumberStart: number;
        lineNumberEnd: number;
        columnStart: number;
        columnEnd: number;
    };
    variableName?: string;
}

export interface FunctionMetadata {
    key: string;
    call: ParsedFunctionCall;
    executed: boolean;
    running: boolean;
    queued: boolean;
    result: RESULT;
    message: string;
    actions: RecordedAction[];
    childActions: RecordedAction[];
    active: boolean;
}

export interface HealModelDecorationOptions extends monaco.editor.IModelDecorationOptions {
    description?: {
        healKey: string;
    };
}

export interface VariablePosition {
    value: string;
    type: 'assignment' | 'usage';
    position: {
        lineNumberStart: number;
        lineNumberEnd: number;
        columnStart: number;
        columnEnd: number;
    };
}
